import React, { Component } from 'react';
import PopUp from '../../../../commonModules/interface/PopUp';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createSubProduct, fetchSubProductsFromMainProduct, fetchBinList } from '../../../../../../../jsx/actions/recyclingAction'
import { Avatar, Box, Dialog, Link, ListItem, ListItemIcon, ListItemText, Table, TableBody, TableCell, TableRow, Typography } from '@material-ui/core';
import { size } from 'lodash-es';
import InputText, { InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { AddCircleOutlineRounded } from '@material-ui/icons';
import { toast } from 'react-toastify';
import FormSubProduct from '../products/SubProducts/FormSubProduct';

class AddInBin extends Component {
    state = { 
        SUB_PRODUCTS : null,
        BINS : null,
        add_in_bin:{
            products: [
                {
                    display:{value: "", label: ""},
                    bin_type: "",
                    sub_product_id: "",
                    quantity: "",
                    max: "",
                    bin_id: "",
                    binDisplay: {value: "", label: ""},
                }
            ],
        },
        errors:{
            products: [
                {
                    sub_product_id: "",
                    quantity: "",
                    bin_id:"",
                }
            ],
        }
     }
    componentDidMount = async () => {
        let SUB_PRODUCTS = await this.props.fetchSubProductsFromMainProduct(this.props.SAV.sav_product_id)
        let BINS = await this.props.fetchBinList(this.props.SAV.sav_product_id)
        console.log('=================SUBS LIST===================');
        console.log({SUB_PRODUCTS, BINS});
        console.log('====================================');
        if (!Array.isArray(SUB_PRODUCTS)) {
            console.warn('[AddInBin] No sub-products returned for product:', this.props.SAV.sav_product_id);
            SUB_PRODUCTS = [];
        }
        if (!Array.isArray(BINS)) {
            BINS = [];
        }
        let products = []
        let errorsP = []
        SUB_PRODUCTS.forEach(prod => {
            products.push({
                display:{
                    value: prod.id, 
                    label:` ${prod.name}`, 
                    max: prod.quantity,
                    disabled: true
                },
                bin_type: prod.bin_type,
                sub_product_id: prod.id,
                quantity: prod.quantity,
                max: prod.quantity,
                bin_id: "",
                binDisplay: {value: "", label: ""},
            })
            
            errorsP.push({                      
                sub_product_id: "",
                quantity: "",
                bin_id: "",
            })      
        })
        this.setState({
            SUB_PRODUCTS,
            BINS,
            numberProd: size(SUB_PRODUCTS),
            add_in_bin: {
                products,
            },
            errors: {
                products: errorsP ,
            }
        })

    }
    
    handleChange = (e) => {  
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        
        console.log('====================================');
        console.log({field, value});
        console.log('====================================');
        if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" || "prod_-product_id-4"

            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);

            let cpProducts = [].concat(this.state.add_in_bin.products)
            cpProducts[index][name] = value
            if(name === "quantity") {   
                if(value === "" || regex.test(value)){// update value only if its a int
                    this.setState({
                        ...this.state,
                        add_in_bin:{
                            ...this.state.add_in_bin,
                            products:cpProducts,
                        }
                    })
                }
                
            } else {
                this.setState({
                    ...this.state,
                    add_in_bin:{
                        ...this.state.add_in_bin,
                        products:cpProducts,
                    }
                })  
            }                  
        } else {
            this.setState({
                ...this.state,
                add_in_bin:{
                    ...this.state.add_in_bin,
                    [field]:value
                }
            })
        }
    }
    handleSelectBins = (option, index) => {
        console.log("SELECT HANDLE",{option, index});

        let value = option.value

        let cpProducts = this.state.add_in_bin.products
        cpProducts[index].bin_id = value
        cpProducts[index].binDisplay = option
        
        this.setState({
            ...this.state,
            add_in_bin:{
                ...this.state.add_in_bin,
                products:cpProducts,
            }
        })        
    }
    createBinList = (bin_type) => {
        const { BINS } = this.state;
        const list = []
        // const list = [{value: "", label: "Chosissez un Bac"}]
        if(BINS){
            BINS.filter(bin => bin.bin_type === bin_type).map(bin => {   
                list.push ({
                    value: bin.id, 
                    label:` ${bin.bin_name}`, 
                })
            })
        }
        return list
    }

    createAddForm = () => {
        return this.state.SUB_PRODUCTS.map((prod, i) => (
            <TableRow key={i} style={{verticalAlign: "top"}}>             
                <TableCell>
                    <Box style={{textAlign: "center", display: "flex", alignItems: "center", justifyContent:"flex-start"}}>
                        <Box p={1}>
                            <Avatar alt={prod.name} src={`/stocks/photos/${prod.photos[0].filename}`} style={{width:"80px", height:"80px"}} /> 
                        </Box>
                        <Box p={1}>
                            <Typography variant="h6">{prod.name}</Typography>
                        </Box>   
                    </Box>
                    {/* <Typography variant="body1">x {prod.quantity}</Typography> */}
                </TableCell>
                <TableCell className="text-center" style={{width: "150px"}}>
                    <InputText 
                        type="number" 
                        min={1} 
                        max={this.state.add_in_bin.products[i].max} 
                        step={10} 
                        className="form-control input-sm" 
                        onChange={this.handleChange} 
                        value={this.state.add_in_bin.products[i].quantity} 
                        name={"prod_-quantity-"+i} 
                        title="Quantité"
                        error={this.state.errors.products[i].quantity}
                        helperText={this.state.add_in_bin.products[i].max ? "Disponible : "+ this.state.add_in_bin.products[i].max :"" }
                        required
                    />
                </TableCell>
                <TableCell>
                    <InputSelectMagasin 
                        onChange={(option) => this.handleSelectBins(option, i)} 
                        options={this.state.BINS ? this.createBinList(this.state.add_in_bin.products[i].bin_type) : []}
                        value={this.state.add_in_bin.products[i].binDisplay} 
                        name={"prod_-bin_id-"+i} 
                        title="Bac de tri"
                        error={this.state.errors.products[i].bin_id}
                        // helperText={this.state.add_in_bin.products[i].bin ? "Prix Unitaire Base: "+ this.state.add_in_bin.products[i].bin :"" }
                        required
                    />
                </TableCell>
            </TableRow>  
        ))
    }
    handleAddProd = () => {// must add new line in the form to add a product to the add_in_bin
        this.setState({
            ...this.state,
            add_in_bin:{
                ...this.state.add_in_bin,
                products:[
                    ...this.state.add_in_bin.products,{
                    display:{},
                    sub_product_id:"",
                    quantity:"",
                    max:"",
                    bin_id: {value: "", label: ""},
                }]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products,{                      
                    sub_product_id:"",
                    quantity:"",
                    bin_id:"",
                    
                }]
            },
            numberProd:this.state.numberProd+1,
        })   
    }
    
    handleDeleteProd = (index) => {
        let cpProducts = [].concat(this.state.add_in_bin.products)
        let cpErrors = [].concat(this.state.errors.products)
        let total = 0;

        cpProducts = [
            ...cpProducts.slice(0,index),
            ...cpProducts.slice(index +1),
        ]
        cpErrors = [
            ...cpErrors.slice(0,index),
            ...cpErrors.slice(index +1),
        ]
        
        this.setState({
            ...this.state,
            add_in_bin:{
                ...this.state.add_in_bin,
                products: cpProducts,
            },
            errors:{
                ...this.state.errors,
                products: cpErrors
            },
            numberProd: this.state.numberProd - 1,
            
        })   
    }
    validate = () => {
        
    }
    handleSubmit = async () => {
        const { add_in_bin } = this.state

        try {
            let products = add_in_bin.products.filter(prod => parseInt(prod.quantity) > 0)
            products = products.map( prod => {
                prod.quantity = parseInt(prod.quantity) 
                return prod
            })
            console.log('====================================');
            console.log({products});
            console.log('====================================');
            let data = {
                sav_id: this.props.SAV.id,
                products: products 
            } 
            const req = await fetch("/stocks/addData",{
                method: "POST",
                headers: { 
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    data,
                    page: "add/bin/products"
                }),
                credentials: 'same-origin',
            })
            let res = await req.json()
            if (res.error) {
                toast.error("ERROR " + res.error)
    
                console.log('====================================');
                console.log("[ERROR]", res.error);
                console.log('====================================');
            } else {
                toast.success("SUCCESS")
                console.log('====================================');
                console.log("[SUCCESS] HANDLE REPAIR");
                console.log('====================================');
                this.props.closeForms()
            }
            
        } catch (error) {
            toast.error("BIG_ERROR handleSubmit error ")

            console.log('====================================');
            console.log("[ERROR]", error);
            console.log('====================================');
        }
        
    }
    render() {
        console.log('=================STATE ADD IN BIN===================');
        console.log(this.state);
        console.log('====================================');
        return (
            <PopUp
                close={this.props.closeForms}
                title="Jeter l'article"
                maxWidth="md"
                submitAction={this.handleSubmit}
            >
                <Box>
                    {this.state.openNewSub &&
                        <Dialog
                            open={this.state.openNewSub}
                            close={() => this.setState({ openNewSub: false})}
                        >
                            <FormSubProduct 
                                {...this.props} // notif from here
                                handleCloseForm={() => this.setState({ openNewSub : false })} 
                                MAIN_PRODUCT_ID={this.props.SAV.sav_product_id} 
                            />
                        </Dialog>
                    }
                    <Table>
                        <TableBody>
                            {this.state.SUB_PRODUCTS && this.createAddForm()}
                            <TableRow className="plus-btn">
                                <TableCell colSpan={3}>
                                    <Link color="secondary" onClick={() => this.setState({ openNewSub : true, })}> 
                                        {/* <AddCircleOutlineRounded />
                                        <span>Ajouter un produit</span>  */}
                                        <ListItem>
                                            <ListItemIcon>
                                                <AddCircleOutlineRounded />
                                            </ListItemIcon>
                                            <ListItemText primary="Créer un Sous Produit" />
                                        </ListItem>
                                    </Link>
                                </TableCell>
                            
                            </TableRow>
                        </TableBody>
                    </Table>
                    {/* 
                        // STEP 1 : Fetch composants 
                        // A: if Composants 
                            // STEP 2: display list of all composant with check box
                            // STEP 3: show each selected component with list of corresponding bin
                                // +--------------+-----+---------------+
                                // |      NOM     | QTY |      BIN      |
                                // +--------------+-----+---------------+
                                // | sub_prodQZE  | 1   |  Plastique 1  |
                                // +--------------+-----+---------------+
                                // | sub_prodXYZ  | 1   |  Panneaux     |
                                // +--------------+-----+---------------+
                                
                        // B: If no Componants
                            // STEP 2: Create composants
                     */}
                </Box>
            </PopUp>
        );
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        fetchSubProductsFromMainProduct,
        fetchBinList
    }, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(AddInBin);